module.exports = __webpack_public_path__ + "static/media/inferno_joker.playngo.ae7a7200.jpeg";